import CryptoJS from 'crypto-js';

// md5加密
export const cryptoMd5 = (str: string) => {
  return CryptoJS.MD5(str).toString();
};

// 使用分块方式计算大文件 MD5，避免阻塞主线程
export const cryptoMd5File = async (file: File): Promise<string> => {
  const chunkSize = 2 * 1024 * 1024; // 2MB 每块
  const chunks = Math.ceil(file.size / chunkSize);
  let currentChunk = 0;

  // 使用 CryptoJS 的增量哈希
  const md5 = CryptoJS.algo.MD5.create();

  while (currentChunk < chunks) {
    const start = currentChunk * chunkSize;
    const end = Math.min(start + chunkSize, file.size);
    const chunk = file.slice(start, end);

    // 读取块
    const buffer = await chunk.arrayBuffer();
    const wordArray = CryptoJS.lib.WordArray.create(buffer as any);

    // 增量更新哈希
    md5.update(wordArray);

    currentChunk++;

    // 让出主线程，避免阻塞 UI
    if (currentChunk < chunks) {
      await new Promise((resolve) => setTimeout(resolve, 0));
    }
  }

  return md5.finalize().toString();
};
